import App from "@frog/source/models/App.js"
import { DefeatAllUnitsOfAffiliation, HealPlayerPartyScript, Dialogue, MoveUnit, MoveEncounterScript, EscapeScript, SpawnUnitsScript } from "@frog/source/data/plotscripts.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Navigation from "@frog/source/models/admin/Navigation.js"
import Dungeon from "@frog/source/data/games/dungeon/dungeon.js"

const dungeon = new Dungeon(
    {
        "partyPicks": ["swordlich","swordskull","splitbone"],
        "enemyJobs": "hammer",
    }
)
const groundColor = {}
groundColor.R = 80
groundColor.G = 50
groundColor.B = 100

export default {
    "slug": "weakness",
    "hasPreparePhase": false,
    "startingEncounter": "1",

    "stage": {
        "image": dungeon.generateEnvironmentArt(groundColor),
        "world": dungeon.generateWorld(),
        "units": dungeon.generateUnits(),
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    // Plotscripts.SpawnPlayerPartyScript(),
                    {"func": () => Audiomix.trigger("Hell:Opening:Music")},
                    {
                        "type": "chapter start",
                        "data": [
                            "Chapter 1",
                            "WEAKNESSES",
                            "Swords beat Axes",
                        ]
                    },
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "good",
                    })
                },
                "events": [
                    {"type": "chapter failure"},
                    {"func": () => Navigation.go("/games/dungeon")},
                    {"func": () => window.location.reload()},
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 1,
                    })
                },
                "events": [
                    HealPlayerPartyScript({"percent": 0.25}),
                    MoveEncounterScript({"nextEncounterKey": 2}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 2,
                    })
                },
                "events": [
                    HealPlayerPartyScript({"percent": 0.25}),
                    MoveEncounterScript({"nextEncounterKey": 3}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 3,
                    })
                },
                "events": [
                    MoveEncounterScript({"nextEncounterKey": 4}),
                    HealPlayerPartyScript({"percent": 0.25}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 4,
                    })
                },
                "events": [
                    MoveEncounterScript({"nextEncounterKey": 5}),
                    HealPlayerPartyScript({"percent": 0.25}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 5,
                    })
                },
                "events": [
                    MoveEncounterScript({"nextEncounterKey": 6}),
                    HealPlayerPartyScript({"percent": 0.25}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 6,
                    })
                },
                "events": [
                    {"func": () => Audiomix.trigger("Hell:Music:Victory")},
                    {"type": "chapter success"},
                    {"func": () => Navigation.go("/games/dungeon/chapters/rivals")},
                ]
            },
        ]
    },
}
